import React, { Fragment, useMemo, useState } from 'react';

import AmenityIcon from 'components/AmenityIcon';
import BottomSheet from 'components/BottomSheet';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { HotelAmenities as HotelAmenitiesModel } from 'services/hotelService';

import SeeMoreHeader from '../SeeMoreHeader';
import { CardContainer, GridContainer, Amenity, AmenitiesContainer, Line } from './styles';

interface Props {
  amenities: string[];
  amenitiesCodes: HotelAmenitiesModel[];
}

const HotelAmenities = ({ amenities, amenitiesCodes }: Props) => {
  const { t } = useStoreTranslation();

  const [seeMoreAmenities, setSeeMoreAmenities] = useState(false);

  const firstSixAmenities = useMemo(() => amenities.slice(0, 6), [amenities]);

  const toggleSeeMoreAmenities = () => setSeeMoreAmenities(!seeMoreAmenities);

  return (
    <CardContainer>
      <SeeMoreHeader
        title={t('hotelDetails.amenities')}
        seeMore={seeMoreAmenities}
        hideSeeMoreButton={amenities.length <= 6}
        onToggleSeeMore={toggleSeeMoreAmenities}
      />
      <AmenitiesContainer>
        <GridContainer>
          {firstSixAmenities.map((name) => {
            const amenity = amenitiesCodes.find((ac) => ac.name === name);

            if (!amenity) return null;

            return (
              <Amenity $card key={`amenity-${amenity.code}`}>
                <AmenityIcon name={amenity.name} code={amenity.code} />
                <span>{amenity.name}</span>
              </Amenity>
            );
          })}
        </GridContainer>

        <BottomSheet modal show={seeMoreAmenities} onClose={toggleSeeMoreAmenities} title={t('hotelDetails.amenities')}>
          {amenities.map((name, index) => {
            const amenity = amenitiesCodes.find((ac) => ac.name === name);

            if (!amenity) return null;

            return (
              <Fragment key={`more-amenity-${amenity.code}`}>
                <Amenity>
                  <AmenityIcon name={amenity.name} code={amenity.code} />
                  <span>{amenity.name}</span>
                </Amenity>
                {index !== amenities.length - 1 && <Line />}
              </Fragment>
            );
          })}
        </BottomSheet>
      </AmenitiesContainer>
    </CardContainer>
  );
};

export default HotelAmenities;
